import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'GameIndex',
    component: () => import('../views/game/IndexView.vue'),
    meta: {
      layout: {
        id: 'game',
        showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/play',
    name: 'GamePlay',
    component: () => import('../views/game/PlayView.vue'),
    meta: {
      layout: {
        id: 'game',
        showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/news',
    name: 'GameNews',
    component: () => import('../views/game/NewsView.vue'),
    meta: {
      layout: {
        id: 'game',
        showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/ratings',
    name: 'GameRatings',
    component: () => import('../views/game/RatingsView.vue'),
    meta: {
      layout: {
        id: 'game',
        showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/docs',
    name: 'GameDocs',
    component: () => import('../views/game/DocsView.vue'),
    meta: {
      layout: {
        id: 'game',
        // showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/logout',
    name: 'GameLogout',
    component: () => import('../views/game/LogoutView.vue'),
    meta: {
      layout: {
        id: 'game',
        showTopFigure: true,
        showBottomFigure: true,
      },
    },
  },
  {
    path: '/admin',
    name: 'Catalog',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Catalog.vue')
  },
  {
    path: '/admin/stocks',
    name: 'Stock',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Stock.vue')
  },
  {
    path: '/admin/newsfeed',
    name: 'Newsfeed',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Newsfeed.vue')
  },
  {
    path: '/admin/library',
    name: 'Library',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Library.vue')
  },
  {
    path: '/admin/directory',
    name: 'Directory',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Directory.vue')
  },
  {
    path: '/admin/gamers',
    name: 'User',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/User.vue')
  },
  {
    path: '/admin/settings',
    name: 'Settings',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Settings.vue')
  },
  {
    path: '/admin/metrics',
    name: 'Metrics',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Metrics.vue')
  },
  {
    path: '/admin/admins',
    name: 'Admin',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Admin.vue')
  },
  {
    path: '/admin/profile',
    name: 'Profile',
    meta: {
      layout: { id: 'main' },
    },
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/admin/auth',
    name: 'Auth',
    meta: {
      layout: { id: 'auth' },
    },
    component: () => import('../views/Auth.vue')
  },
  {
    path: '/admin/reset',
    name: 'Reset',
    meta: {
      layout: { id: 'auth' },
    },
    component: () => import('../views/Reset.vue'),
  },
  {
    path: '*',
    redirect: '/',
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
